import { AdminResourcesSection } from "@/pages/Admin";

export default function AdminResourcesPage() {
    return (
        <div data-testid="admin-resources-page">
            <AdminResourcesSection />
        </div>
    );
}
